import { hasVariantCapability } from '../../capability-matrix';

import { KpiCard } from './KpiCard';

import type { KpiVM, SupervisorVariant } from '../../view-models';
import type React from 'react';

export interface KpiRowSupervisorProps {
  kpis: KpiVM[];
  variant: SupervisorVariant;
}

export function KpiRowSupervisor({ kpis, variant }: KpiRowSupervisorProps): React.JSX.Element {
  const visible = kpis.filter((k) => k.cap === undefined || hasVariantCapability(k.cap, variant));
  return (
    <div className="kpi-row" role="list">
      {visible.map((kpi) => (
        <KpiCard key={kpi.id} kpi={kpi} />
      ))}
    </div>
  );
}
